import React, { useRef, useEffect } from 'react';
import { FaSearch, FaBars } from 'react-icons/fa';
import CategoryDropdown from './CategoryDropdown';

const SecondaryNavbar = ({
  categories,
  handleCategoryClick,
  searchQuery,
  setSearchQuery,
  searchResults,
  showSearchDropdown,
  setShowSearchDropdown,
  handleInputChange,
  handleKeyPress,
  handleSearch,
  isMobileCategoryOpen,
  setIsMobileCategoryOpen,
  isCategoriesDropdownOpen,
  setIsCategoriesDropdownOpen,
  navigate,
  formatPrice
}) => {
  const searchContainerRef = useRef(null);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // Search dropdown handling
  useEffect(() => {
    const handleSearchClickOutside = (event) => {
      if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
        setShowSearchDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleSearchClickOutside);
    return () => document.removeEventListener('mousedown', handleSearchClickOutside);
  }, []);

  useEffect(() => {
    if (searchQuery.trim() === '') setShowSearchDropdown(false);
  }, [searchQuery]);

  const handleResultClick = (product) => {
    setShowSearchDropdown(false);
    navigate(`/home/product/${product.anProductKey}`, { state: { product } });
  };

  const toggleCategoriesDropdown = (e) => {
    e?.stopPropagation();
    setIsCategoriesDropdownOpen(!isCategoriesDropdownOpen);
  };

  return (
    <div className="secondary-navbar">
      <div className="container">
        <div className="secondary-nav-content">
          {/* Categories Dropdown */}
          <div className={`categories-dropdown ${isCategoriesDropdownOpen ? 'active' : ''}`}>
            <button
              className="categories-button"
              onClick={toggleCategoriesDropdown}
            >
              <FaBars className="menu-icon" />
              Kategorije
            </button>

            {isCategoriesDropdownOpen && (
              <div onClick={(e) => e.stopPropagation()}>
                <CategoryDropdown
                  categories={categories}
                  handleCategoryClick={(category) => {
                    handleCategoryClick(category);
                    setIsCategoriesDropdownOpen(false);
                  }}
                  onClose={() => setIsCategoriesDropdownOpen(false)}
                />
              </div>
            )}
          </div>

          {/* Search Container */}
          <div className="search-container" ref={searchContainerRef}>
            <input
              type="text"
              placeholder="Pronađi proizvode..."
              className="search-input"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                handleInputChange(e);
              }}
              onKeyPress={handleKeyPress}
              onFocus={() => setShowSearchDropdown(!!searchQuery)}
            />
            <FaSearch className="search-icon" onClick={handleSearch} />

            {showSearchDropdown && (
              <div className="search-dropdown">
                {searchResults.length > 0 ? (
                  searchResults.map((product) => (
                    <div
                      key={product.anProductKey}
                      className="search-result-item"
                      onClick={() => handleResultClick(product)}
                    >
                      <img
                        src={product.urlImages?.[0]?.url ||
                          `https://resource.ewe.rs/products/${product.acProduct?.replace(/[^a-zA-Z0-9]/g, '')}.jpg`}
                        alt={product.acName}
                        className="search-result-image"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = '/noImage.jpg';
                        }}
                      />
                      <div className="search-result-info">
                        <div className="search-result-brand">{product.acDept}</div>
                        <div className="search-result-name">{product.acName}</div>
                        <div className={`search-result-price ${
                          (product.isPromotion === 1 || product.anDiscount > 0) ? 'sale-price' : ''
                        }`}>
                          {formatPrice(product.anRetailPrice)} RSD
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="no-results">Nema pronađenih proizvoda</div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Mobile Category Dropdown */}
      {isMobileCategoryOpen && (
        <div className="mobile-category-dropdown mobile-fullscreen">
          <div className="mobile-dropdown-header">
            <h3>Kategorije</h3>
            <button
              className="close-button"
              onClick={() => setIsMobileCategoryOpen(false)}
            >
              ✕
            </button>
          </div>
          <div className="mobile-category-content">
            <CategoryDropdown
              categories={categories}
              handleCategoryClick={(category) => {
                handleCategoryClick(category);
                setIsMobileCategoryOpen(false);
              }}
              onClose={() => setIsMobileCategoryOpen(false)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SecondaryNavbar;